import React from 'react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Clock, AlertCircle, Plus } from 'lucide-react';

const PlaceholderDepartmentView = ({ department }) => {
  if (!department) return null;
  const Icon = department.icon;

  return (
    <div className="flex-1 flex flex-col items-center justify-center text-center p-8">
      <div 
        className="h-24 w-24 rounded-2xl bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center mb-6 border-2 border-dashed border-amber-400"
        style={{ boxShadow: '0 0 30px rgba(245, 158, 11, 0.2)' }}
      >
        <Icon className="h-12 w-12 text-amber-600 dark:text-amber-400" />
      </div>
      <div className="flex items-center gap-2 mb-2">
        <span className="text-2xl">{department.emoji}</span>
        <h3 className="text-xl font-bold text-amber-700 dark:text-amber-300">{department.name}</h3>
      </div>
      <Badge variant="outline" className="mb-4 border-amber-300 text-amber-700 dark:text-amber-300">
        <Clock className="h-3 w-3 mr-1" />
        Coming Soon
      </Badge>
      <p className="text-sm text-muted-foreground max-w-md mb-6">
        {department.description}
      </p>
      <div className="bg-amber-50 dark:bg-amber-950/20 border border-amber-200 dark:border-amber-800 rounded-lg p-4 max-w-sm">
        <div className="flex items-center gap-2 text-amber-800 dark:text-amber-200 mb-2">
          <AlertCircle className="h-4 w-4" />
          <span className="font-semibold text-sm">Department Not Yet Built</span>
        </div>
        <p className="text-xs text-amber-700 dark:text-amber-300">
          This department will be built in a future phase. No agents exist yet.
        </p>
      </div>
      <Button 
        variant="outline" 
        className="mt-6 border-amber-300 text-amber-700 hover:bg-amber-50 dark:border-amber-700 dark:text-amber-300" 
        disabled
      >
        <Plus className="h-4 w-4 mr-2" />
        Add Agents (Coming Soon)
      </Button>
    </div>
  );
};

export default PlaceholderDepartmentView;